import React from "react";
import { useTranslation } from "src/context/Translations/context";
import { RCCBadge } from "react-common-components";
import { AuditItemSituation } from "../interface";

export interface IBadgeAuditSituation{
    value?: number;
}

const BadgeAuditSituation: React.FC<IBadgeAuditSituation> = ({
	value
}) => {
	const { translate } = useTranslation();

	const colorSituation = () => {
		let color: "green" | "red" | "blue" | "grey" | undefined;
		switch (value) {
		case AuditItemSituation.CONFORM:
			color = "green";
			break; 
		case AuditItemSituation.NOT_CONFORM:
			color = "red";
			break; 
		case AuditItemSituation.OPPORTUNITY_IMPROVEMENT:
			color = "blue";
			break;
		case AuditItemSituation.OBSERVATION:
			color = "grey";
			break;
		default:
			color = undefined;
			break; 
		}
		return color;

	};

	const textSituation = () => {
		switch (value) {
		case AuditItemSituation.CONFORM:
			return translate("Conforme"); 
		case AuditItemSituation.NOT_CONFORM:
			return  translate("Não Conforme");
		case AuditItemSituation.OPPORTUNITY_IMPROVEMENT:
			return translate("Oportunidade Melhoria");
		case AuditItemSituation.OBSERVATION:
			return translate("Observação");
		default:
			return  " ";
		} 
	};

	return (
		<>
			<RCCBadge color={colorSituation()}
				styleInline="padding: 2px 8px; font-size: 0.78rem; cursor: pointer;"
			>
				{textSituation()}
			</RCCBadge>
		</>
	);
};


export default BadgeAuditSituation;
